import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { fetchBillingStatus } from '../utils/billing';

// Shown on the Dashboard and at the top of Settings when the subscription has
// ended (cancelled or expired). The company keeps read-only access; the server
// refuses new work with SUBSCRIPTION_LAPSED. A trial whose storm is over keeps
// its own "Trial Complete" banner instead, because it never subscribed.
//
// For the owner it adds one line asking for the expected return month while
// none is set. Settings passes its own billing status (null while loading, so
// the line waits); elsewhere the banner reads it once for an owner.
//
// Reuses the trial banner's styles in index.css.
function LapsedBanner({ billing }) {
  const { isSubscriptionEnded, isOwner } = useAuth();
  const ended = isSubscriptionEnded();
  const owner = isOwner();
  const passedIn = billing !== undefined;
  const [fetched, setFetched] = useState(null);

  useEffect(() => {
    if (passedIn || !ended || !owner) return undefined;
    let live = true;
    fetchBillingStatus()
      .then((data) => { if (live) setFetched(data); })
      .catch(() => { /* the line is optional; the banner stands without it */ });
    return () => { live = false; };
  }, [passedIn, ended, owner]);

  if (!ended) return null;

  const status = passedIn ? billing : fetched;
  const askReturnMonth = owner && status && !status.returnMonth;

  return (
    <div className="trial-banner trial-expired lapsed-banner" role="status">
      <div className="trial-banner-content">
        <div className="trial-text">
          Your subscription has ended. You can still view your customers, history and reports.
          Resubscribe to run routes again.
          {askReturnMonth && (
            <div style={{ marginTop: '6px' }}>
              When do you expect to be back? <Link to="/settings">Set your expected return month in Settings</Link> and
              we will send you one reminder before then.
            </div>
          )}
        </div>
        <Link to="/pricing" className="trial-upgrade-btn">Resubscribe</Link>
      </div>
    </div>
  );
}

export default LapsedBanner;
